import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ReportParamsService} from '~/app/core/reports/services/report-params.service';
import {ParameterBase} from '~/app/core/reports/models/ParameterBase';
import {Report} from '~/app/core/reports/models/report';
import {ReportService} from '~/app/core/reports/services/report.service';
import {Subscription, lastValueFrom} from 'rxjs';
import {Group} from '~/app/core/reports/models/group';
import {Chain} from '~/app/core/reports/models/chain';
import * as moment from 'moment';
import {UserService} from '~/app/core/services/user.service';
import {AppEnums} from '~/app/web/AppProvider/AppEnums';
import {paths} from '~/app/app-paths';
import {HomeOffice} from '@model/HomeOffice';
import {LocalStorageIndexedService} from '~/app/web/AppProvider/LocalStorageIndexedService';
import {Router} from '@angular/router';
import {ExtractPost} from '~/app/core/reports/models/extractPost';
import {FSInvoiceDialogService} from "~/app/core/services/fsinvoice.dialog.service";
import { LoadingIndicatorHelper } from '~/app/core/services/loading-indicator-helper';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit, OnDestroy {
  mainForm: FormGroup;
  parameters: ParameterBase<string>[] = [];
  public categories: any;
  public _reports: Report[];
  groupHeaders: Group[];
  public currentReport: any;
  public loading: boolean;
  chains: Chain[];
  value: any;
  filteredReports: any;
  filteredReportsValue: any;
  public mainParam: string[];
  public formChanges = new Subscription();
  public  showExtract: boolean;
  public listItems: Array<string> = ['PDF', 'Spreadsheet', 'CSV'];
  selectedOption =  'PDF';
  reportTypeHidden = false;
  private selectedHomeOffice: HomeOffice;
  currentSavedFields: any;
  constructor(public reportParam: ReportParamsService,
              public reportService: ReportService, public formb: FormBuilder,
              public localStorage: LocalStorageIndexedService
              , public userService: UserService, public router: Router,
              public loadingService: LoadingIndicatorHelper,
              public fsInvoiceDialog: FSInvoiceDialogService) { }


  ngOnDestroy(): void {
    this.reportService.chains = null;
    this.reportService.groupHeaders = null;
    this.formChanges.unsubscribe();
  }

   async ngOnInit() {

    this.initializeArray();

    console.log(this.selectedHomeOffice);
    console.log(this.localStorage.getFromSession(AppEnums.HOME_OFFICE));
    if (this.userService.selectedHomeOffice) {
      this.selectedHomeOffice = this.userService.selectedHomeOffice;
    } else {
      if (this.localStorage.getFromSession(AppEnums.HOME_OFFICE)) {
        this.selectedHomeOffice = this.localStorage.getFromSession(AppEnums.HOME_OFFICE);
        this.userService.selectedHomeOffice = this.selectedHomeOffice;
        const username = this.userService.getUserName();
        this.loadingService.show();
        lastValueFrom(this.reportService.getAllReports(username, this.selectedHomeOffice.hoId)).then(async (result) => {
          this._reports = result;
          await this.reportService.getStores(this.selectedHomeOffice.hoId, this.userService.getUserName());
          console.log(this._reports);
          this.findUniqueCategories(this._reports);
          this.loadingService.hide();
        });
      } else {
        this.fsInvoiceDialog.showErrorNotificationForDuration("No home office is selected.", 2000);
        await this.router.navigate([paths.home]);
      }
    }
  }

  async Submit() {
    const formValue = this.mainForm.value;
    this.loadingService.show();
    await this.buildURL(formValue, this.currentReport);

  }

  findUniqueCategories(array) {
    if (array == null) {return; }
    this.categories = array.filter(
      (thing, i, arr) => arr.findIndex(t => t.categoryCode === thing.categoryCode) === i
    );
  }

  findReportsFromCategory(catCode: string) {
    this.filteredReports = this._reports.filter((report) => report.categoryCode === catCode);
  }

  valueChangeInternal($event: any) {
    this.value = $event;
    this.findReportsFromCategory($event.categoryCode);
    this.filteredReportsValue = [];
    this.rebuildForm([]);
  }

  reportChange($event: any) {
    this.rebuildForm([]);
    this.currentReport = $event;
    this.showExtract = false;
    this.selectedOption = $event.output;
    this.reportTypeHidden = true;
    lastValueFrom(this.reportService.getReportParams($event.categoryCode, $event.id)).then((result) => {
      this.mainParam = result;
      this.rebuildForm(result);
    });
  }
  subscribeForValueChanges() {
    this.formChanges.unsubscribe();
    this.formChanges = this.mainForm.valueChanges.subscribe((changes) => { return this.changeForm(changes);
    } );
  }

  extractCheck() {
    this.showExtract = true;
  }

  rebuildForm(params: string[]) {
    this.showExtract = false;
    const formatData = this.reportParam.getTypes(params);
    console.log("Test load",formatData);
    const form = this.reportParam.buildFormUI(formatData);
      this.parameters = form;
      this.mainForm = this.reportParam.toFormGroup(form);
     this.subscribeForValueChanges();

     }

  private initializeArray() {
    this.mainForm = this.formb.group({
      chains: []
    });

  }
  private createAdhocDownload(formValue: any, currentReport: any) {
      console.log(this.currentSavedFields);
      const extractExport = new ExtractPost();
      const username = this.userService.getUserName();
      const hotid = this.userService.selectedHomeOffice.hoId;
      extractExport.hoId = +hotid;
      extractExport.userId = username.toUpperCase();
      extractExport.reportID = currentReport.id;
      extractExport.fileName = 'adhoc.xls';
      if ( formValue['p_BEG_BUS_DT.p_END_BUS_DT'] != null) {
        const dateObject = formValue['p_BEG_BUS_DT.p_END_BUS_DT'];
        extractExport.begDate = moment(dateObject.start).format('YYYY-MM-DD');
        extractExport.endDate = moment(dateObject.end).format('YYYY-MM-DD');
      }

      if ( formValue['p_CHN_STOR_LST'] != null) {
        extractExport.chnStores = formValue['p_CHN_STOR_LST'];
      }
    extractExport.selectedFields = this.currentSavedFields.map((value) => {
        return value.fieldName;
      });


      lastValueFrom(this.reportService.postExtractExport(extractExport)).then((data: any) => {
        const blob = new Blob([data], {type: 'text/csv', });
        const download = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = `${currentReport.reportURL}_export.csv`;
        link.href = download;
        link.click();
      }).catch().finally(() => {
        this.loadingService.hide();
      });
  }

  private buildCognosUrl(formValue: any, currentReport: any) {
    const hotid = this.userService.selectedHomeOffice.hoId;
    const username = this.userService.getUserName();
    const mapForm = document.createElement('form');
    mapForm.action = currentReport.serverURL;
    mapForm.target = 'Map';
    mapForm.method = 'POST'; // or "post" if appropriate
    const obj = document.createElement('input');
    mapForm.appendChild(obj);
    this.mainParam.map(param => {
      const item = this.parameters.find((x => x.key.includes(param.trim())));
      const mapInput = document.createElement('input');
      if (item == null) {
        mapInput.type = 'hidden';
        mapInput.name = param.trim();
        if (param.trim() === 'p_HO_ID') {
          mapInput.value = hotid;
        } else if (param.trim() === 'p_SEC_USER_ID') {
          mapInput.value = username.toUpperCase();
        }
        mapForm.appendChild(mapInput);
      } else {

        if (item.key === 'p_BEG_BUS_DT.p_END_BUS_DT') {
          const keySplit = item.key.split('.');
          keySplit.forEach((key) => {
            if (!mapForm.children.namedItem(key)) {
              if (key === 'p_BEG_BUS_DT') {
                const date = moment(formValue[item.key].start).format('YYYY-MM-DD');
                console.log(date);
                mapInput.type = 'hidden';
                mapInput.name = key;
                mapInput.value = date;
              } else {
                const date = moment(formValue[item.key].end).format('YYYY-MM-DD');
                mapInput.type = 'hidden';
                mapInput.name = key;
                mapInput.value = date;
              }
            }
            mapForm.appendChild(mapInput);
          });
        } else if (item.key.includes('DT')) {
          const date = moment(formValue[item.key].start).format('YYYY-MM-DD');
          mapInput.type = 'hidden';
          mapInput.name = item.key;
          mapInput.value = date;
          mapForm.appendChild(mapInput);
        } else {
          mapInput.type = 'hidden';
          mapInput.name = item.key;
          mapInput.value = formValue[item.key].toString();
          mapForm.appendChild(mapInput);
        }
      }
    });

    this.reportParam.constantParams.map(cparam => {
      if (cparam.entity === 'action') {
        mapForm.action = currentReport.serverURL;
      } else if (cparam.entity === 'form name') {
        mapForm.name = cparam.value;
      } else if (cparam.entity === 'method') {
        mapForm.method = cparam.value;
      } else if (cparam.entity === 'ui.object') {
        const mapInput = document.createElement('input');
        mapInput.type = 'hidden';
        mapInput.name = cparam.entity;
        mapInput.value = currentReport.reportURL;
        mapForm.appendChild(mapInput);
      } else if (cparam.entity === 'run.outputFormat') {
        const mapInput = document.createElement('input');
        mapInput.type = 'hidden';
        mapInput.name = cparam.entity;
        if (this.selectedOption === 'Spreadsheet') {
          mapInput.value = 'singleXLS';
        } else {
          mapInput.value = this.selectedOption;
        }
        mapForm.appendChild(mapInput);
      }
      if (cparam.type !== 'CFM') {
        const mapInput = document.createElement('input');
        mapInput.type = 'hidden';
        mapInput.name = cparam.entity;
        mapInput.value = cparam.value;
        mapForm.appendChild(mapInput);
      }
    });
    document.body.appendChild(mapForm);
    window.open('', 'Map');
    mapForm.submit();
    this.loadingService.hide();
  }
  public async buildURL(formValue: any, currentReport: any) {

    try {

      if (currentReport.categoryCode === 'ADHOC') {
        await this.createAdhocDownload(formValue, currentReport);
      } else {
        await this.buildCognosUrl(formValue, currentReport);
      }


    } catch (e) {
      this.loadingService.hide();
    } finally {

      const elem = document.getElementsByName('reportForm');
      if (elem != null && elem.length > 0) {
        elem.item(0).remove();
      }
    }
  }

  public OpenURL(url) {
    console.log(url);
    window.open(url, '_blank');
  }

  private changeForm(changes: any) {
    if ( changes.hasOwnProperty('p_CHN_STOR_LST')) {

      if ( changes['p_CHN_STOR_LST'] != null && changes['p_CHN_STOR_LST'].length > 0) {
        if (this.value.categoryCode === 'ADHOC') {
          this.showExtract = true;
        }

      } else {
        this.showExtract = false;
      }
    }
  }

  typeChange($event: any) {
    this.selectedOption = $event;
  }


}
